import { useMutation, useQueryClient } from 'react-query'
import { QUERY_KEYS } from 'src/constants'

import { userService } from 'src/services/user.service'
import { IProfileUserResponse } from 'src/types'

export const useHideUserWelcome = (userId?: string) => {
  const queryClient = useQueryClient()

  return useMutation(() => userService.hideUserWelcome(), {
    onSuccess() {
      queryClient.setQueryData([QUERY_KEYS.USER, userId], (prev?: IProfileUserResponse) => {
        return prev
          ? {
              ...prev,
              show_welcome: false,
            }
          : ({} as IProfileUserResponse)
      })
    },
  })
}
